import { Bill } from '@melio/platform-api';

export const isEbill = (bill: Bill) => bill.origin === 'fiserv';
